import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { motion, MotionConfig } from 'framer-motion';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/portfolio/Navbar';
import ParticleCanvas from './components/portfolio/ParticleCanvas';
import HeroSection from './components/portfolio/HeroSection';
import StatsBar from './components/portfolio/StatsBar';
import AboutSection from './components/portfolio/AboutSection';
import SkillsSection from './components/portfolio/SkillsSection';
import ExperienceSection from './components/portfolio/ExperienceSection';
import EducationSection from './components/portfolio/EducationSection';
import ProjectsSection from './components/portfolio/ProjectsSection';
import PublishedPackagesSection from './components/portfolio/PublishedPackagesSection';
import RecognitionsSection from './components/portfolio/RecognitionsSection';
import FloatingChatbot from './components/portfolio/FloatingChatbot';
import ContactSection from './components/portfolio/ContactSection';
import Footer from './components/portfolio/Footer';
import './App.css';

const Portfolio = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="relative min-h-screen" style={{ background: '#080C14' }}>
      <ParticleCanvas />
      <Navbar />
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <main>
          <HeroSection />
          <StatsBar />
          <AboutSection />
          <SkillsSection />
          <ExperienceSection />
          <PublishedPackagesSection />
          <ProjectsSection />
          <EducationSection />
          <RecognitionsSection />
          <ContactSection />
        </main>
        <Footer />
      </motion.div>
      <FloatingChatbot />
      <Analytics />
    </div>
  );
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
